import { useQuery } from "@apollo/client/react";
import { useMemo } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

import { GET_USER_PERSONAL_API_KEYS } from "./gql";
import { UserPersonalApiKeyRow } from "./types";

const useUserPersonalApiKeysData = (userId: string, username: string) => {
  const { viewer } = useTypedContext(AccountContext);

  const { data, loading, error } = useQuery(GET_USER_PERSONAL_API_KEYS, {
    variables: { id: userId },
  });

  const isViewerKey = username === viewer.id;

  const apiKeys = useMemo<UserPersonalApiKeyRow[]>(
    () =>
      (data?.managedUser.personalApiKeys ?? [])
        .filter((apiKey) => !apiKey.disabled)
        .map((apiKey) => ({ ...apiKey, owner: apiKey.owner ?? username, isViewerKey })),
    [data?.managedUser.personalApiKeys, username, isViewerKey]
  );

  return { apiKeys, isInitialLoading: loading && !data, error };
};

export default useUserPersonalApiKeysData;
